import { useQuery } from '@tanstack/react-query';
import { fetchAuthSession } from 'aws-amplify/auth';
import { apiFetch } from 'utils/apiUtils';

interface IRole {
  person_orgid: string;
  person_roleid: string;
  org_code: string;
  role_name: string;
  role_code: string;
}

interface IUser {
  userinfo: {
    nhsid_useruid: string;
    name: string;
    nhsid_nrbac_roles: IRole[];
    sub: string;
    selected_roleid: string;
  };
}

interface IUserInfo {
  roleName: string;
}

export default function useFetchUser() {
  return useQuery({
    queryKey: ['user'],
    queryFn: async (): Promise<IUserInfo | null> => {
      const authSession = await fetchAuthSession();
      if (!authSession.tokens) {
        return null;
      }

      try {
        const user = await apiFetch<IUser>({
          path: 'user',
          method: 'GET',
          accessToken: authSession.tokens?.accessToken.toString() || '',
        });

        if (!user) {
          return null;
        }

        const selectedRole = user.userinfo.nhsid_nrbac_roles.find((r) => r.person_roleid === user.userinfo.selected_roleid);
        if (!selectedRole) {
          return null;
        }

        return {
          roleName: selectedRole.role_name
            .split(':')[0]
            .replaceAll('"', ''),
        };
      } catch {
        return null;
      }
    },
    enabled: true,
  });
}
